module.exports = __webpack_public_path__ + "static/img/logo.9c4d45d6.png";